import ModelUtil from '@leverege/model-util';
import Attributes from "../attribute/Attributes.js";
const TYPE = 'visibilizer.IfEmpty';
function create() {
  return {
    type: TYPE,
    value: true
  };
}
function visibilityFor(model, obj, context) {
  const {
    model: detailModel
  } = context;
  const val = model.value == null ? detailModel?.value?.showIfEmpty : model.value;
  const attributeValue = Attributes.get(context.attrName, obj?.type, obj?.data);
  return val ? true : isNotEmpty(attributeValue);
}
function isNotEmpty(value) {
  if (Array.isArray(value)) {
    return value.some(val => {
      return isNotEmpty(val);
    });
  }
  if (typeof value === 'string') {
    return value.trim().length !== 0;
  }
  return value != null;
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('value'),
  visibilityFor
};